export default __webpack_public_path__ + "assets/icons/upload.e80fb486.svg";